import React, { ReactNode, useState } from 'react'
import { useCurrentUser, useLocationContext } from '@therms/react-modules'
import { VerifyUserGeoForLocationLogs } from './components/VerifyUserGeoForLocationLogs'

interface LocationLogsUserAnPGeoConditionalProps {
  children: ReactNode
}

function LocationLogsUserAnPGeoConditional({
  children,
}: LocationLogsUserAnPGeoConditionalProps) {
  const currentUser = useCurrentUser()
  const { location } = useLocationContext(true)
  const userGeoCheckRequired =
    !!currentUser.anp.role.ops.restrictions.mustBeAtLocationToCreateEditLogs ||
    !location.geo

  const [pass, setPass] = useState(() => {
    if (!userGeoCheckRequired) return true

    return false
  })

  if (pass) return children

  return <VerifyUserGeoForLocationLogs onVerified={() => setPass(true)} />
}

export { LocationLogsUserAnPGeoConditional }
